import {HttpHandler} from "../../../utils/handler/HttpHandler";

export class MaturityLoanService {
    constructor() {
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral/loan/maturity');
    }
    matureLoan(loanId){
        return this.axiosInstance({
            url: '/' + loanId,
            method: 'post'
        }).then(res => res);
    }
}